module.exports = __webpack_public_path__ + "static/media/printer_card.0d872a9b.png";